import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Droppable } from "@hello-pangea/dnd"

import Text from "components/Text/Text"
import { Flex, FlexItem } from "components/Flex"
import ReservationDocument from "./ReservationDocument"
import { DocumentCategoryWithDocuments } from "models/DocumentCategoryWithDocuments"
import { IApiLink } from "@/types"

interface IReservationDocumentsCategoryProps {
    category: DocumentCategoryWithDocuments
    disabled?: boolean
    onDocumentDelete: (link: IApiLink) => Promise<void>
}

const ReservationDocumentsCategory: FC<React.PropsWithChildren<IReservationDocumentsCategoryProps>> = ({
    category,
    disabled,
    onDocumentDelete,
}) => {
    const { t } = useTranslation()

    return (
        <Droppable droppableId={category.id} isDropDisabled={disabled}>
            {(provided) =>
                <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="py-4 border-grey-100-between">
                    <Flex className="mb-3" alignItems="baseline" justifyContent="space-between" gap="1.6rem">
                        <Text type="h4">{category.name}</Text>
                        {category.documents.length > 0 &&
                            <FlexItem shrink={0} className="color-grey-500">
                                {t("common.xDocuments", { count: category.documents.length })}
                            </FlexItem>
                        }
                    </Flex>
                    <div>
                        {category.documents.length > 0
                            ? category.documents.map((document, idx) => (
                                <ReservationDocument
                                    key={document.id}
                                    index={idx}
                                    document={document}
                                    disabled={disabled}
                                    onDelete={onDocumentDelete}
                                />
                            ))
                            : (category.isReserved ? <div className="color-grey-500 p-4 text-center">{category.emptyPlaceholder}</div> : null)
                        }
                    </div>
                </div>
            }
        </Droppable>
    )
}

export default ReservationDocumentsCategory
